import Appbar from "components/Appbar";
import { Container, Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Footer from "components/Footer";

const Bg = styled(`div`)`
  overflow: hidden;
  position: relative;
  &:before {
    content: "";
    position: absolute;
    z-index: -1;
    background: #fafafa;
    width: 100vw;
    height: 100%;
  }
`;
const ButtonDashboard = styled(Button)`
  height: 42px;
  width: 180px;
  border-radius: 60px;
  margin-bottom: 150px;
`;
export default function Index({ children }) {
  const history = useHistory();
  const { t } = useTranslation();
  const onBack = () => {
    history.push("/mainmenu");
  };
  return (
    <Bg>
      <Appbar />
      <Container>
        <div>{children}</div>
        <ButtonDashboard variant="contained" onClick={onBack}>
          {t("backmain")}
        </ButtonDashboard>
        <Footer />
      </Container>
    </Bg>
  );
}
